import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class GlobalSettings {
    politicasUrl: string = environment.apiUrl
    processosUrl: string = environment.apiUrl
    motorUrl: string = environment.apiUrl
    securityApiUrl: string = `${environment.apiUrl}/security`
    reportUrl: string = environment.apiUrl
}
